import { Button } from "react-bootstrap";
import { useNavigate } from "react-router";

function HostedCheckoutEmbedButton()
{
    const navigate = useNavigate();

    function handleClick() {
      navigate("/checkout");
    }

    return  <Button variant="primary"  onClick={handleClick}>Launch Hosted Checkout</Button>

}

export default HostedCheckoutEmbedButton;